import { ReactNode, useContext, useLayoutEffect } from 'react';
import { Routes, useLocation } from 'react-router-dom';
import { UserContext } from 'context/userContext';
import { setLoginGatePending } from 'lib/authSession';
import { ScrollToTop } from 'components/ScrollToTop/ScrollToTop';
import { LoginGate } from './LoginGate';

type AuthGateProps = {
  routes: ReactNode;
  workInProgressRoutes: ReactNode;
  notFound: ReactNode;
};

export function AuthGate({
  routes,
  workInProgressRoutes,
  notFound,
}: AuthGateProps) {
  const { loggedUser } = useContext(UserContext);
  const location = useLocation();

  useLayoutEffect(() => {
    setLoginGatePending(!loggedUser);
  }, [loggedUser]);

  if (!loggedUser) {
    const from = `${location.pathname}${location.search}`;
    return <LoginGate from={from} />;
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
        {routes}
        {workInProgressRoutes}
        {notFound}
      </Routes>
    </>
  );
}
